import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'

import { ReportSection } from '@/components/reports/ReportSection'
import { Button } from '@/components/ui/button'
import { api } from '@/lib/api'
import { apiErrorMessage } from '@/lib/apiErrorMessage'

export function ExpenseSummaryReportPanel() {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)

  async function load() {
    setLoading(true)
    setError('')
    try {
      const { data } = await api.get('/reports/expenses-summary')
      const payload = data?.data ?? data ?? {}
      setRows(payload.by_category ?? payload.categories ?? payload.rows ?? [])
      setTotal(Number(payload.total ?? payload.grand_total ?? 0))
    } catch (err) {
      setError(apiErrorMessage(err, 'Unable to load expenses summary.'))
      setRows([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  return (
    <ReportSection
      title="Expenses summary"
      description="Cash-day expenses by category for the current branch."
      actions={
        <Button type="button" variant="outline" size="sm" onClick={() => void load()} disabled={loading}>
          Refresh
        </Button>
      }
    >
      {loading ? (
        <div className="flex justify-center py-12 text-muted-foreground">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : error ? (
        <p className="text-sm text-destructive">{error}</p>
      ) : (
        <div className="space-y-4">
          <p className="text-sm font-medium">Total: {total.toFixed(2)}</p>
          <ul className="divide-y rounded-xl border">
            {rows.length === 0 ? (
              <li className="px-4 py-6 text-sm text-muted-foreground">No expenses in range.</li>
            ) : (
              rows.map((row) => (
                <li key={row.category ?? row.name ?? JSON.stringify(row)} className="flex justify-between px-4 py-3 text-sm">
                  <span>{row.category ?? row.name ?? 'Other'}</span>
                  <span className="font-medium">{Number(row.amount ?? row.total ?? 0).toFixed(2)}</span>
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </ReportSection>
  )
}
